'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Icon = require('../Icon-405a216c.js');
require('react');
require('@jobber/design');



exports.Icon = Icon.Icon;
